
{
  "fr": {
    "titleKlarna": "Klarna Payment Badge"
  }
}
